// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"5d1badf7","952":"1d62a81c"}[chunkId] + ".chunk.js";
};